export class InvestorProfile {
  investorType: number;
  isAnonymous?: boolean;
}
